var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column align-start flex-1",class:_vm.$store.meetingStore.state.selectedType === 2 || _vm.$store.meetingStore.state.selectedType === 3 ? 'scrollable-list-bak':'',attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('FullHeader'),_c('MeetingsContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }